import styled from "@emotion/styled";
export const MessageWrapper = styled.div`
  margin-bottom: 15px;
  width: 80%;
  max-width: 300px;
  text-align: ${(props) => (props.mine ? "right" : "left")};
  float: ${(props) => (props.mine ? "right" : "left")};
`;
